module.exports = __webpack_public_path__ + "img/partners-claping-hands.6f63088e.svg";